var render, staticRenderFns
import script from "./StatCardsByTypeDoughnutChart.vue?vue&type=script&lang=js&"
export * from "./StatCardsByTypeDoughnutChart.vue?vue&type=script&lang=js&"
import style0 from "./StatCardsByTypeDoughnutChart.vue?vue&type=style&index=0&id=33eae891&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33eae891",
  null
  
)

export default component.exports